import styled, { css } from "styled-components";

export const CounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
`;

export const Label = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.1rem;
  color: ${({ color }) => color || "#222"};
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: 0.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  cursor: pointer;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
      svg {
        stroke: ${color};
      }
    `}
  &:hover:not(:disabled) {
    background: ${({ color }) => color + "22"};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ValueBox = styled.span`
  min-width: 48px;
  text-align: center;
  font-variant-numeric: tabular-nums;
  font-size: 1.1rem;
  font-weight: 500;
  color: ${({ color }) => color || "#222"};
  letter-spacing: 0.5px;
`;
